/**
 * Obfuscated front-end paths for internal operations console.
 * Use route names (AdminLoginPanel, AdminMainPage, EditProduct) in app code when possible.
 */

export const ADMIN_GATEWAY_PATH = "/ipromiseafrica/operations/desk-portal";
export const ADMIN_WORKSPACE_PATH = "/ipromiseafrica/operations/desk-console";
export const ADMIN_CATALOG_EDIT_BASE = "/ipromiseafrica/operations/desk-console/inventory";

export function adminCatalogEditPath(id) {
  return `${ADMIN_CATALOG_EDIT_BASE}/${encodeURIComponent(String(id))}`;
}
